import { movies, type Movie } from "@/mocks/movies";
import { newsList, type NewsItem } from "@/mocks/news";

export type { Movie, NewsItem };

export function getMovieById(id: string | undefined): Movie | undefined {
  if (!id) return undefined;
  return movies.find((item) => item.id === id);
}

export function getRelatedMovies(movie: Movie, limit = 4): Movie[] {
  return movies
    .filter((item) => item.id !== movie.id)
    .sort((a, b) => {
      const scoreA =
        (a.type === movie.type ? 2 : 0) +
        a.genres.filter((genre) => movie.genres.includes(genre)).length +
        (a.cast.some((name) => movie.cast.includes(name)) ? 2 : 0);
      const scoreB =
        (b.type === movie.type ? 2 : 0) +
        b.genres.filter((genre) => movie.genres.includes(genre)).length +
        (b.cast.some((name) => movie.cast.includes(name)) ? 2 : 0);
      return scoreB - scoreA || b.popularity - a.popularity;
    })
    .slice(0, limit);
}

export function getNewsById(id: string | undefined): NewsItem | undefined {
  if (!id) return undefined;
  return newsList.find((item) => item.id === id);
}

export function getRelatedNews(item: NewsItem, limit = 3): NewsItem[] {
  const sameCategory = newsList.filter((news) => news.id !== item.id && news.category === item.category);
  const others = newsList.filter((news) => news.id !== item.id && news.category !== item.category);
  return [...sameCategory, ...others].slice(0, limit);
}

export type MovieFilters = {
  keyword: string;
  type: string;
  region: string;
  year: string;
  sort: string;
};

export function filterMovies(filters: MovieFilters): Movie[] {
  const keyword = filters.keyword.trim().toLowerCase();
  const result = movies.filter((movie) => {
    const matchKeyword =
      !keyword ||
      [movie.title, movie.originalTitle, movie.summary, movie.tagline, movie.director, ...movie.cast, ...movie.genres]
        .join(" ")
        .toLowerCase()
        .includes(keyword);
    const matchType = !filters.type || filters.type === "全部" || movie.type === filters.type;
    const matchRegion = !filters.region || filters.region === "全部" || movie.region === filters.region;
    const matchYear =
      !filters.year ||
      filters.year === "全部" ||
      (filters.year === "2023及以前" ? movie.year <= 2023 : String(movie.year) === filters.year);
    return matchKeyword && matchType && matchRegion && matchYear;
  });

  const sorted = [...result];
  if (filters.sort === "score") {
    sorted.sort((a, b) => b.rating - a.rating);
  } else if (filters.sort === "popular") {
    sorted.sort((a, b) => b.popularity - a.popularity);
  } else {
    sorted.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
  }
  return sorted;
}